import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4da70c90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "常用文件")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_4 = { class: "block-content" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_ctx.data.length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            class: "empty",
            "image-size": 100,
            description: "暂无常用文件"
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
        return (_openBlock(), _createElementBlock("a", {
          class: "file",
          href: item.url,
          key: index,
          target: "_blank"
        }, [
          _createElementVNode("img", {
            src: require('@/assets/img/file/' + item.type + '.png'),
            class: "icon",
            alt: ""
          }, null, 8, _hoisted_6),
          _createElementVNode("p", _hoisted_7, _toDisplayString(item.name), 1)
        ], 8, _hoisted_5))
      }), 128))
    ])
  ]))
}